import { useStore } from '@/store/useStore';
import { perms, type RolePermissions } from './permissions';

/** Права текущего пользователя (или пустые, если не авторизован). */
export function usePerms(): RolePermissions {
  return perms(useStore((s) => s.currentUser));
}
